<div *ngIf="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animation-fade-in">
    <div
        class="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col animation-slide-up relative border border-transparent dark:border-slate-800">

        <!-- Header -->
        <div
            class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-white dark:bg-slate-900 sticky top-0 z-10">
            <h3 class="text-lg font-bold text-slate-800 dark:text-white tracking-tight flex items-center gap-2">
                <span class="material-icons text-amber-500 dark:text-amber-400">edit</span>
                แก้ไขทะเบียนรถ
            </h3>
            <button type="button" (click)="closeModal()"
                class="w-8 h-8 rounded-full flex items-center justify-center hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 transition-all border-none cursor-pointer bg-transparent">
                <span class="material-icons">close</span>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6 space-y-4">
            <!-- Vehicle image: only when URL exists; visible after successful load -->
            <ng-container *ngIf="previewImageSrc as src">
                <img [src]="src" alt="" class="hidden" (load)="onImageLoad()" (error)="onImageError()" />
                <button *ngIf="showImage" type="button" (click)="openZoom()"
                    class="license-thumb group relative w-full aspect-[16/10] rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 p-0 cursor-zoom-in block">
                    <img [src]="src" alt="รูปรถตอนเข้า" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                    <span class="license-thumb__hint">
                        <span class="material-icons text-base">zoom_in</span>
                        คลิกเพื่อซูม
                    </span>
                </button>
            </ng-container>

            <!-- Info Text -->
            <div
                class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700 text-sm space-y-2">
                <div class="flex justify-between gap-3">
                    <span class="text-slate-500 dark:text-slate-400 shrink-0">สถานที่ (Site):</span>
                    <span class="font-bold text-slate-700 dark:text-slate-200 text-right break-all">{{ data?.siteEvName || '-' }}</span>
                </div>
                <div class="flex justify-between gap-3">
                    <span class="text-slate-500 dark:text-slate-400 shrink-0">ช่องจอด (Space):</span>
                    <span class="font-bold text-slate-700 dark:text-slate-200 text-right break-all">{{ data?.spaceName || '-' }}</span>
                </div>
            </div>

            <!-- Input -->
            <div>
                <label class="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">ทะเบียนรถ</label>
                <input type="text" [(ngModel)]="newLicensePlate" placeholder="กรอกทะเบียนรถ..." [disabled]="isLoading"
                    class="w-full bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-xl px-4 py-3 text-slate-800 dark:text-white font-bold focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-500 outline-none transition-all placeholder:font-normal placeholder:text-slate-400 dark:placeholder:text-slate-500 disabled:bg-slate-100 dark:disabled:bg-slate-900/50 disabled:text-slate-500 dark:disabled:text-slate-600">
            </div>
        </div>

        <!-- Footer -->
        <div
            class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/80 flex flex-col-reverse sm:flex-row justify-between gap-3">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isLoading"
                class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
                <span class="material-icons text-[18px]">history</span>
                ดูประวัติ
            </button>
            <div class="flex justify-end gap-3 ml-auto w-full sm:w-auto">
            <button type="button" (click)="closeModal()" [disabled]="isLoading"
                class="px-5 py-2.5 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed border-none cursor-pointer bg-transparent">
                ยกเลิก
            </button>
            <button type="button" (click)="save()" [disabled]="isLoading"
                class="cursor-pointer px-5 py-2.5 rounded-xl bg-yellow-500/70 dark:bg-yellow-500 text-white font-bold hover:bg-yellow-500 dark:hover:bg-yellow-600 shadow-md dark:shadow-none active:scale-95 transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed border-none">
                <span *ngIf="isLoading"
                    class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                <span>{{ isLoading ? 'กำลังบันทึก...' : 'บันทึก' }}</span>
            </button>
            </div>
        </div>

    </div>

    <!-- Zoom lightbox -->
    <div *ngIf="isZoomOpen && previewImageSrc as zoomSrc"
        class="license-zoom fixed inset-0 z-[60] flex flex-col bg-slate-950/92 backdrop-blur-md"
        (click)="closeZoom()">

        <div class="license-zoom__toolbar" (click)="$event.stopPropagation()">
            <span class="text-xs font-bold text-slate-300">{{ (zoomScale * 100) | number:'1.0-0' }}%</span>
            <div class="flex items-center gap-1.5">
                <button type="button" (click)="zoomOut()" [disabled]="zoomScale <= zoomMin"
                    class="license-zoom__btn" title="ซูมออก">
                    <span class="material-icons">zoom_out</span>
                </button>
                <button type="button" (click)="resetZoom()" class="license-zoom__btn" title="รีเซ็ต">
                    <span class="material-icons">fit_screen</span>
                </button>
                <button type="button" (click)="zoomIn()" [disabled]="zoomScale >= zoomMax"
                    class="license-zoom__btn" title="ซูมเข้า">
                    <span class="material-icons">zoom_in</span>
                </button>
                <button type="button" (click)="closeZoom()" class="license-zoom__btn" title="ปิด">
                    <span class="material-icons">close</span>
                </button>
            </div>
        </div>

        <div class="license-zoom__stage flex-1 overflow-auto p-4"
            (click)="$event.stopPropagation()"
            (wheel)="onZoomWheel($event)">
            <div class="license-zoom__canvas"
                [style.transform]="'scale(' + zoomScale + ')'">
                <img [src]="zoomSrc" alt="ซูมรูปรถ" class="license-zoom__img" />
            </div>
        </div>

        <p class="text-center text-[11px] text-slate-400 pb-4 font-medium">เลื่อนลูกกลิ้งเมาส์เพื่อซูม · คลิกพื้นหลังเพื่อปิด</p>
    </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && activityEntityId"
  [entityType]="activityEntityTypes.EvTransaction"
  [entityId]="activityEntityId"
  title="ประวัติรายการ EV"
  [subtitle]="'#' + activityEntityId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
